import {forwardRef, useEffect, useState} from "react";
import {QRCodeCanvas} from "qrcode.react";
import * as React from "react";
import LoadingSpinner from "./LoadingSpinner";

const QRCode = forwardRef(
    (
        {
            style = {},
            positionStyle = {},
            value,
            size,
            bgColor,
            fgColor,
            level = "H",
            heading = "Device Register QR Code",
            isLoading,
            showQrCloseButton = false,
            handleQRPopUpCloseChange = () => {},
        },
        ref
    ) =>{

        const [qrIsLoading, setQrIsLoading] = useState(true);

        useEffect(() => {
            setQrIsLoading(true);
            const timer = setTimeout(() => {
                setQrIsLoading(false);
            }, 1000);

            return () => clearTimeout(timer);
        }, [value]);

        return(
            <>
                <div
                    style={{
                        ...positionStyle,
                        padding: "10px 10px 10px 0",
                        justifyContent: "space-between",
                    }}
                >
                    {heading && <h3 style={{marginBottom: "10px"}}>{heading}</h3>}
                    <div style={{display: "flex", gap: "5px"}}>
                        {showQrCloseButton && (
                            <button
                                className="ui primary right floated button"
                                type="button"
                                onClick={(e) => {
                                    handleQRPopUpCloseChange()
                                }}
                                style={{display: "flex", alignItems: "center"}}
                            >
                                <div style={{display: "flex", alignItems: "center"}}>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        Close QR
                                    </div>
                                </div>
                            </button>
                        )}
                    </div>
                </div>

                {qrIsLoading ? (
                    <LoadingSpinner height={"60vh"} showText={false} />
                ) : (
                    <div style={{...positionStyle}}>
                        <div
                            className="ag-theme-quartz ag-grid-container"
                            style={{
                                marginTop: "2%",
                                padding: "1% 0.5%",
                                borderRadius: "10px",
                                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                backgroundColor: "#426bf3",
                                display: "inline-block",
                                maxWidth: "50%",
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "white",
                                    opacity: 0.9,
                                    borderRadius: "10px",
                                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                                    marginTop: "1.5rem",
                                    width: "90%",
                                    maxWidth: "300px",
                                    padding: "10px 0",
                                    textAlign: "center",
                                    margin: "0 auto",
                                }}
                            >

                                <QRCodeCanvas
                                    value={value}
                                    size={size}
                                    bgColor={bgColor}
                                    fgColor={fgColor}
                                    level={level}
                                    style={{
                                        maxWidth: "90%",
                                        height: "auto",
                                    }}
                                />
                                <h3
                                    style={{
                                        color: "#426bf3",
                                        fontSize: "1rem",
                                        margin: "10px 0 0", // Add margin to separate from QR code
                                        fontFamily: "Arial, sans-serif",
                                        fontWeight: "bold",
                                    }}
                                >
                                    Scan Me
                                </h3>
                            </div>
                        </div>
                    </div>
                )}
            </>
        )
    }
);

export default QRCode;
